export default {
  title: "Password Recovery",
  back: "Go back",
  submit: "Submit",
  successMessage:
    "Password recovery link has been sent <br /> to the specified e-mail."
};
